<template>
  <transition name="editTables">
      <div class="edit-table" v-if="showEditTable">
          <div class="editWrapper">
            <el-form :model="tableFrom" ref="tableFormRef" :rules="rules" class="tableFormClass">
              <div class="eTitle">{{title}}</div>
              <div class="orderNum">
                <div class="oTitle pTitle">题目序号: </div>
                <div>{{index}}</div>
              </div>
              <div class="subject">
                <p class="oTitle pTitle">请输入题目内容: </p>
                <div class="subjectWrapper">
                  <el-form-item prop='subject' class="subjectWrapperItem">
                      <el-input
                      type="textarea"
                      :rows="3"
                      placeholder="请输入题目(限制在50字符以内)"
                      maxlength="50"
                      show-word-limit
                      v-model="tableFrom.subject">
                    </el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="options">
                <p class="pTitle">请输入各个选项内容: </p>
                <div v-for="(item, index) in tableFrom.options" :key="item.id">
                  <p>{{item.optioname}} .</p>
                  <el-form-item :prop='item.prop' class="optionsSingleItem">
                      <el-input
                        type="textarea"
                        :rows="2"
                        :placeholder="item.placeholder"
                        v-model="tableFrom[item.prop]">
                      </el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="rightResult">
                <p class="pTitle">请选择正确的答案: </p>
                <div class="resultWrapper">
                    <el-form-item prop='rightResult' class="rightResultForm">
                        <el-radio-group v-model="tableFrom.rightResult">
                          <el-radio label='A'>A</el-radio>
                          <el-radio label='B'>B</el-radio>
                          <el-radio label='C'>C</el-radio>
                          <el-radio label='D'>D</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
              </div>
              <div class="buttonWrapper">
                <p class="pTitle">是否提交信息: </p>
                <div class="obuttonWrapper">
                    <el-button @click='no()'>取消</el-button>
                    <el-button type="primary" @click='yes("tableFormRef")'>确定</el-button>
                </div>
              </div>
            </el-form>
          </div>
        </div>
  </transition>
</template>

<script>
import {mapMutations, mapGetters} from 'vuex'
export default {
  name: 'EditTable',
  data() {
    return {
      from: '',
      index: 0,
      showEditTable: false,
      olocation: '',
      tableFrom: {
        subject: '',
        options: [
          {'id': 'A', 'optioname': 'A', 'prop': 'optiondetialA', 'placeholder': '请输入A选项内容'},
          {'id': 'B','optioname': 'B',  'prop': 'optiondetialB', 'placeholder': '请输入B选项内容'},
          {'id': 'C','optioname': 'C',  'prop': 'optiondetialC', 'placeholder': '请输入C选项内容'},
          {'id': 'D','optioname': 'D',  'prop': 'optiondetialD', 'placeholder': '请输入D选项内容'},
        ],
        optiondetialA: '',
        optiondetialB: '',
        optiondetialC: '',
        optiondetialD: '',
        rightResult: ''
      },
      rules: {
        subject: [{ required: true, message: "题目不能为空!", trigger: "blur" }],
        optiondetialA: [{required: true, message: "选项A内容不能为空!", trigger: "blur"}],
        optiondetialB: [{required: true, message: "选项B内容不能为空!", trigger: "blur"}],
        optiondetialC: [{required: true, message: "选项C内容不能为空!", trigger: "blur"}],
        optiondetialD: [{required: true, message: "选项D内容不能为空!", trigger: "blur"}],
        rightResult: [{ required: true, message: "请选择正确答案", trigger: "change" }]
      }
    }
  },
  computed: {
    ...mapGetters({
      'tableData': 'getAllTableInfo'
    }),
    title() {
      if (this.from == 'new') {
        return '新建题目';
      } else if (this.from == 'modify') {
        return '修改题目';
      }
    }

  },
  methods: {
    ...mapMutations({
      'addnew': 'addSingleTableInfo',
      'updatetable': 'updateSingleTable'
    }),
    show(ofrom, tValue) {
      this.showEditTable = true;
      this.from = ofrom;
      this.olocation = tValue;
      if (this.from == 'new') {
        this.index = this.tableData.length + 1;
        if (!!this.tableFrom.subject) this.tableFrom.subject = '';
        if (!!this.tableFrom.optiondetialA) this.tableFrom.optiondetialA = '';
        if (!!this.tableFrom.optiondetialB) this.tableFrom.optiondetialB = '';
        if (!!this.tableFrom.optiondetialC) this.tableFrom.optiondetialC = '';
        if (!!this.tableFrom.optiondetialD) this.tableFrom.optiondetialD = '';
        if (!!this.tableFrom.rightResult) this.tableFrom.rightResult = '';
      } else {
        this.index = tValue + 1;
        this.tableFrom.subject = this.tableData[tValue].subject;
        this.tableFrom.optiondetialA = this.tableData[tValue].soptionsArr[0];
        this.tableFrom.optiondetialB = this.tableData[tValue].soptionsArr[1];
        this.tableFrom.optiondetialC = this.tableData[tValue].soptionsArr[2];
        this.tableFrom.optiondetialD = this.tableData[tValue].soptionsArr[3];
        this.tableFrom.rightResult = this.tableData[tValue].rightResult;
      }
    },
    hide() {
      this.showEditTable = false;
    },
    yes(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 验证通过
          let tableIf = {
            oId: this.from == 'new' ? new Date().getTime().toString() : this.tableData[this.olocation].oId,
            subject: this.tableFrom.subject,
            soptions: 'A.'+this.tableFrom.optiondetialA+'; B.'+this.tableFrom.optiondetialB +'; C.'+this.tableFrom.optiondetialC +'; D.'+this.tableFrom.optiondetialD,
            rightResult: this.tableFrom.rightResult,
            soptionsArr: [this.tableFrom.optiondetialA, this.tableFrom.optiondetialB, this.tableFrom.optiondetialC, this.tableFrom.optiondetialD]
          }
          if (this.from == 'new') {
            this.addnew(tableIf);
          } else {
            this.updatetable(tableIf);
          }
          this.resetForm(formName); // 重置
          setTimeout(() => {
            this.no();
            this.$message.success("操作成功! ");
          }, 20);
        } else {
          this.$message.error("验证不通过, 请检查各选项填写是否正确! ");
          return false;
        }
      });
    },
    no() {
      this.hide();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
@import "~@/common/mixin.scss";

.edit-table {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.7);
  z-index: 999;
  opacity: 1;
  &.editTables-enter-active, &.editTables-leave-active {
    transition: opacity 0.2s;
    -webkit-transition: opacity 0.2s;
  }
  &.editTables-enter, &.editTables-leave-to {
    opacity: 0;
  }
  .editWrapper {
    position: absolute;
    top: 40px;
    width: 50%;
    height: 82%;
    overflow-y: auto;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    border-radius: 5px;
    background: white;
    padding: 8px 5px;
    line-height: 1.5;
    .pTitle {
      padding-bottom: 6px;
    }
    .eTitle {
      text-align: center;
      font-weight: bold;
    }
    .buttonWrapper {
      .obuttonWrapper {
        text-align: right;
        .el-button--primary {
          background-color: #003c8d;
          border-color: #003c8d;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/EditTable.vue